// Notification service — teacher-composed push/email notifications.
import { apiPost, apiGet } from './apiClient';

export type RecipientType = 'student_push' | 'parent_email' | 'teacher_push';

export interface SendNotificationRequest {
  recipientType: RecipientType;
  /** Required for student_push / parent_email */
  studentId?: string;
  /** Required for teacher_push */
  teacherId?: string;
  title: string;
  message: string;
}

export interface SendNotificationResponse {
  success: boolean;
  delivered: boolean;
  detail: string;
  studentName: string;
  /** 'in_app' when there was no FCM token and the message was saved to the student's inbox */
  fallback?: 'in_app';
}

export interface SentNotification {
  id: string;
  title: string;
  message: string;
  sentVia: string;
  status: string;
  createdAt: string;
  recipient: { name: string; email: string } | null;
}

export const notificationService = {
  async send(req: SendNotificationRequest): Promise<SendNotificationResponse> {
    return apiPost<SendNotificationResponse>('/dashboard/teacher/notify', req);
  },

  async getSent(): Promise<SentNotification[]> {
    const res = await apiGet<{ success: boolean; notifications: SentNotification[] }>('/dashboard/teacher/sent-notifications');
    return res.notifications;
  },
};
